import { Box, Paper, Stack, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import React from "react";

const YourFreedom = () => {
  const features = [
    {
      id: 1,
      title: "LOW FEES,\nMAXIMUM CONTROL",
      description: "NO SURPRISES,\nJUST FAIR AND\nTRANSPARENT PRICING",
    },
    {
      id: 2,
      title: "INSTANT\nTRANSFERS",
      description: "MOVE MONEY INSTANTLY\nBETWEEN EPAYR\nUSERS AT NO COST",
    },
    {
      id: 3,
      title: "GLOBAL\nREACH",
      description:
        "SEND AND RECEIVE MONEY\nACROSS BORDERS WITH\nCOMPETITIVE EXCHANGE RATES",
    },
    {
      id: 4,
      title: "SAFE &\nSECURE",
      description:
        "YOUR FUNDS ARE\nPROTECTED WITH TOP-TIER\nSECURITY STANDARDS",
    },
  ];

  return (
    <Stack spacing={8} sx={{ 
        margin: "0 auto",
        maxWidth: '1320px',
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "0 20px",
        width: "100%",
        }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems={{sm: "center", xs: "flex-start"}}
        width="100%"
        alignSelf="stretch"
        flexDirection={{ xs: "column", sm: "row" }}
        gap={{xs: '16px', sm: '32px'}}
      >
        <Typography
          sx={{
            fontWeight: 500,
            lineHeight: 1.2,
            fontSize: { xs: "28px", sm: "36px" },
            fontStyle: "normal",
            textTransform: "uppercase",
            fontFamily: "Manrope"
          }}
        >
          <Box component="span" color="#321338">
            Your Money,
            <br />
            Your{" "}
          </Box>
          <Box component="span" color="#9484ba">
            Freedom
          </Box>
        </Typography>

        <Typography
          fontSize={16}
          color="text.secondary"
          fontWeight={500}
          textAlign="left"
        >
          MANAGING YOUR FINANCES
          <br />
          SHOULDN'T BE COMPLICATED
        </Typography>
      </Box>

      <Paper
        elevation={0}
        sx={{
          p: 6,
          bgcolor: "#f8f5eb",
          borderRadius: 4,
          width: '100%'
        }}
      >
        <Stack spacing={4}>
          <Typography color="#321338" fontWeight={600} fontSize={{ xs: 24, sm: 36 }}>
            WHY CHOOSE EPAYR?
          </Typography>

          <Grid container spacing={4}>
            {features.map((feature) => (
              <Grid size={{xs: 12, sm: 6, md: 3}} key={feature.id}>
                <Stack spacing={2}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      bgcolor: "#efe9d9",
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="subtitle11" color="darkPurple.500" fontWeight={500}>
                      {feature.id}
                    </Typography>
                  </Box>

                  <Stack spacing={1}>
                    <Typography
                      color="darkPurple.500"
                      fontWeight={500}
                      fontSize={{ xs: 20, sm: 22 }}
                      sx={{ whiteSpace: "pre-line" }}
                    >
                      {feature.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      fontWeight={500}
                      sx={{ whiteSpace: "pre-line" }}
                    >
                      {feature.description}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default YourFreedom;
